export enum RestrictType {
  Duration = 1,
  Count = 2,
}
